import {
  AfterViewInit,
  Component,
  ElementRef,
  booleanAttribute,
  inject,
  input,
} from '@angular/core';

import { BaseComponent } from '../base.component';

export type inputStyle = 'default' | 'auth' | 'profile';

const INPUT_STYLE: { [name: string]: { [name: string]: string } } = {
  'ui-input': {
    default: 'gray',
    auth: 'mb-4 pt-3 pb-3 px-8 py-8 border-gray-seed shadow-sm transition-colors placeholder:text-muted-base placeholder:text-dark-muted focus-visible:outline-none focus-visible:ring-1 focus-visible:ring-accent-base disabled:opacity-50',
    profile:
      'px-4 py-3 text-[16px] border-black text-black focus-visible:outline-none',
  },
};

@Component({
  selector: 'input[ui-input],textarea[ui-input]',
  imports: [],
  templateUrl: './input.component.html',
})
export class InputComponent extends BaseComponent implements AfterViewInit {
  readonly style = input<inputStyle>('default');
  readonly disabled = input(false, { transform: booleanAttribute });
  readonly prepend = input(false, { transform: booleanAttribute });
  readonly append = input(false, { transform: booleanAttribute });

  constructor() {
    super();
    this._elementRef = inject<ElementRef<HTMLElement>>(ElementRef);

    this.addToClassList(
      'flex w-full h-12 rounded-[16px] bg-transparent text-sm border'
    );
  }

  ngAfterViewInit(): void {
    this.addToClassList(INPUT_STYLE['ui-input'][this.style()]);

    if (this.disabled()) {
      this.addToClassList('cursor-not-allowed opacity-50');
      this.getHostElement().setAttribute('disabled', 'disabled');
    }

    if (this.prepend()) {
      this.addToClassList('pl-10');
    }

    if (this.append()) {
      this.addToClassList('pr-10');
    }
  }
}
